module.exports = __webpack_public_path__ + "static/media/darkBus.a0cfb6ee.png";